// API 配置
export const API_BASE_URL = process.env.NODE_ENV === "production" ? "https://api.gugudata.ai" : "http://localhost:8000";

// API 版本
export const API_VERSION = "v1";

// 完整的 API URL
export const API_URL = `${API_BASE_URL}/api/${API_VERSION}`;
